import { useThemeStore } from '../stores/themeStore';
import { darkColors, lightColors, AppColors } from '../theme';

export function useAppColors(): AppColors {
  const mode = useThemeStore((s) => s.mode);
  return mode === 'dark' ? darkColors : lightColors;
}
